import { FC } from 'react';

const CloseIcon: FC = () => {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <g id="Group 1">
                <path
                    id="Vector 100"
                    d="M1.92896 1.92896L16.0711 16.0711"
                    stroke="#0A163C"
                    strokeWidth="2"
                    strokeLinecap="round"
                />
                <path
                    id="Vector 103"
                    d="M16.071 1.92896L1.92891 16.0711"
                    stroke="#0A163C"
                    strokeWidth="2"
                    strokeLinecap="round"
                />
            </g>
        </svg>
    );
};

export { CloseIcon };
